const colorData = [
  '#1162FF',
  '#0febd5',
  '#FFDD64',
  '#a84ef7',
  '#ee3585',
  '#6a14a8',
  '#301ff0',
  '#12d740',
  '#FC6BFF',
  '#eb6635',
];

export default colorData;
